import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_SURGE_TEMPLATE_DETAILS, GET_SURGE_TEMPLATE_DETAILS_SUCCESS, GET_SURGE_TEMPLATE_DETAILS_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getSurgeTemplateDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    delete filteredHeaders['X-Requested-By'];

    const { templateId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-templates/${templateId}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_SURGE_TEMPLATE_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SURGE_TEMPLATE_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SURGE_TEMPLATE_DETAILS_ERROR, payload: error });
  }
}

export function* watchgetSurgeTemplateDetails() {
  yield takeEvery(GET_SURGE_TEMPLATE_DETAILS, getSurgeTemplateDetails);
}

function* getSurgeTemplateDetailsSaga() {
  yield all([fork(watchgetSurgeTemplateDetails)]);
}

export default getSurgeTemplateDetailsSaga;
